module.exports = __webpack_public_path__ + "img/4.4af4aea8.png";